<div class="container home-dispatch-map">
  <!-- Search Bar -->
  <div class="search-bar">
    <div class="search-input-wrapper">
      <i class="fa fa-search search-icon"></i>
      <input
        type="text"
        class="form-control search-input"
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchInput()"
        placeholder="Search..."
        autocomplete="off"
      />
      <button
        *ngIf="searchText"
        class="btn btn-link clear-btn"
        (click)="clearSearch()"
        title="Clear search"
      >
        <i class="fa fa-times"></i>
      </button>
    </div>
    <span class="result-count loading-text" *ngIf="loading">
      <i class="fa fa-spinner fa-spin"></i> Loading...
    </span>
  </div>

  <!-- Map + detail card pinned by clicking a marker -->
  <div class="map-wrapper">
    <app-dispatch-map
      [cards]="cards"
      [mapCenter]="mapCenter"
      [mapZoom]="mapZoom"
      [showTypes]="showTypes"
      (markerClick)="onMapMarkerClick($event)"
    ></app-dispatch-map>

    <div class="pinned-card" *ngIf="selectedCard">
      <div class="pinned-header" [ngClass]="'pinned-' + selectedCardType">
        <i
          class="fa"
          [ngClass]="{
            'fa-user': selectedCardType === 'driver',
            'fa-truck': selectedCardType === 'tractor',
            'fa-list': selectedCardType === 'trailer',
          }"
        ></i>
        <span class="pinned-title">{{ selectedTitle }}</span>
        <button type="button" class="pinned-close" (click)="closeSelectedCard()" title="Close">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="pinned-body">
        <!-- Road call -->
        <div class="pc-roadcall" *ngIf="selectedRoadCall as rc">
          <i class="fa fa-exclamation-triangle"></i>
          <span class="pc-roadcall-status" [ngClass]="getRoadCallStatusClass(rc.status)">
            {{ rc.status }}
          </span>
          <span class="pc-roadcall-number" *ngIf="rc.number">#{{ rc.number }}</span>
          <span class="pc-roadcall-date" *ngIf="rc.opened">{{ rc.opened | date: "MM/dd/yy" }}</span>
        </div>

        <!-- Driver -->
        <ng-container *ngIf="selectedDriver as d">
          <div class="pc-identity">
            <img class="pc-avatar" [src]="getDriverPictureUrl(d)" [alt]="d.name" />
            <div>
              <div class="pc-name">{{ d.name }}</div>
              <div class="pc-sub">{{ d.driverNo }} - {{ getDriverTypeLabel(d.driverType) }}</div>
            </div>
          </div>
          <div class="pc-row" *ngIf="d.schedulingTeamName">
            <span class="pc-label"><i class="fa fa-users"></i> Team</span>
            <span class="pc-value">
              {{ d.schedulingTeamName }}
              <span class="pc-sub" *ngIf="d.schedulingTeamBoardName">{{
                d.schedulingTeamBoardName
              }}</span>
            </span>
          </div>
          <div class="pc-row" *ngIf="d.location">
            <span class="pc-label"><i class="fa fa-map-marker"></i> Location</span>
            <span class="pc-value">
              {{ d.location }}
              <span class="pc-age" *ngIf="d.locationAge">({{ d.locationAge }})</span>
            </span>
          </div>
          <div class="pc-row" *ngIf="d.tractorNumber">
            <span class="pc-label"><i class="fa fa-truck"></i> Tractor</span>
            <span class="pc-value">{{ d.tractorNumber }}</span>
          </div>
          <div class="pc-row" *ngIf="d.trailerNumber">
            <span class="pc-label"><i class="fa fa-list"></i> Trailer</span>
            <span class="pc-value">
              {{ d.trailerNumber }}
              <span class="pc-sub" *ngIf="d.attachedTrailerNumbers.length > 1"
                >+{{ d.attachedTrailerNumbers.length - 1 }} more</span
              >
            </span>
          </div>
          <div class="pc-stats">
            <span *ngIf="d.hoursOfService !== null && d.hoursOfService !== undefined">
              <i class="fa fa-clock-o"></i> {{ d.hoursOfService | number: "1.1-1" }} HOS
            </span>
            <span><i class="fa fa-road"></i> {{ d.milesLast7Days | number }} mi</span>
          </div>
          <div class="pc-quals" *ngIf="d.productQualifications.length">
            <span class="pc-qual" *ngFor="let q of d.productQualifications">{{ q }}</span>
          </div>
        </ng-container>

        <!-- Tractor -->
        <ng-container *ngIf="selectedTractor as t">
          <div class="pc-row" *ngIf="t.currentLocation">
            <span class="pc-label"><i class="fa fa-map-marker"></i> Location</span>
            <span class="pc-value">
              {{ t.currentLocation }}
              <span class="pc-age" *ngIf="t.locationAge">({{ t.locationAge }})</span>
            </span>
          </div>
          <div class="pc-row" *ngIf="t.attachedTrailerNumbers.length">
            <span class="pc-label"><i class="fa fa-list"></i> Trailers</span>
            <span class="pc-value">{{ t.attachedTrailerNumbers.join(", ") }}</span>
          </div>
          <div class="pc-row" *ngIf="t.terminal">
            <span class="pc-label"><i class="fa fa-building"></i> Terminal</span>
            <span class="pc-value">{{ t.terminal }}</span>
          </div>
          <div class="pc-stats">
            <span
              class="pc-badge"
              [class.pc-badge-success]="t.inService"
              [class.pc-badge-danger]="!t.inService"
            >
              {{ t.inService ? "In Service" : "Out of Service" }}
            </span>
          </div>
        </ng-container>

        <!-- Trailer -->
        <ng-container *ngIf="selectedTrailer as t">
          <div class="pc-row" *ngIf="t.currentLocation">
            <span class="pc-label"><i class="fa fa-map-marker"></i> Location</span>
            <span class="pc-value">
              {{ t.currentLocation }}
              <span class="pc-age" *ngIf="t.locationAge">({{ t.locationAge }})</span>
            </span>
          </div>
          <div class="pc-row" *ngIf="t.equipmentCode">
            <span class="pc-label"><i class="fa fa-tag"></i> Equipment</span>
            <span class="pc-value">{{ t.equipmentCode }}</span>
          </div>
          <div class="pc-row" *ngIf="t.attachedTractorNumber">
            <span class="pc-label"><i class="fa fa-truck"></i> On Tractor</span>
            <span class="pc-value">{{ t.attachedTractorNumber }}</span>
          </div>
          <div class="pc-row" *ngIf="t.terminal">
            <span class="pc-label"><i class="fa fa-building"></i> Terminal</span>
            <span class="pc-value">{{ t.terminal }}</span>
          </div>
          <div class="pc-stats">
            <span
              class="pc-badge"
              [class.pc-badge-success]="t.inService"
              [class.pc-badge-danger]="!t.inService"
            >
              {{ t.inService ? "In Service" : "Out of Service" }}
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
